import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CartProvider } from "./context/CartContext";
import { Provider } from 'react-redux';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { HelmetProvider } from "react-helmet-async";
import store from './store'

const theme = createTheme({
  typography: { fontFamily: "Poppins, Arial, sans-serif" },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <CartProvider>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </CartProvider>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
